"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readCsvFile = readCsvFile;
exports.readXlsFile = readXlsFile;
exports.getFileExtension = getFileExtension;

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _sync = _interopRequireDefault(require("csv-parse/lib/es5/sync"));

var _dropRight = _interopRequireDefault(require("lodash/dropRight"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _last = _interopRequireDefault(require("lodash/last"));

var _range = _interopRequireDefault(require("lodash/range"));

var errorUtils = _interopRequireWildcard(require("./errorUtils"));

function readBuffer(_x) {
  return _readBuffer.apply(this, arguments);
}

function _readBuffer() {
  _readBuffer = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(file) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (window.FileReader) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            return _context.abrupt("return", new Promise(function (resolve) {
              var fileReader = new FileReader();

              fileReader.onload = function (event) {
                return resolve(event.target.result);
              };

              fileReader.onerror = function () {
                return resolve(null);
              };

              fileReader.readAsArrayBuffer(file);
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _readBuffer.apply(this, arguments);
}

function readText(_x2) {
  return _readText.apply(this, arguments);
}

function _readText() {
  _readText = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(file) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (window.FileReader) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", null);

          case 2:
            return _context2.abrupt("return", new Promise(function (resolve) {
              var fileReader = new FileReader();

              fileReader.onload = function (event) {
                return resolve(event.target.result);
              };

              fileReader.onerror = function () {
                return resolve(null);
              };

              fileReader.readAsText(file);
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _readText.apply(this, arguments);
}

function readCsvFile(_x3) {
  return _readCsvFile.apply(this, arguments);
}

function _readCsvFile() {
  _readCsvFile = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(file) {
    var text, csv, _csv, _csv2, columns, rows, defaultedColumns, trimmedColumns;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return readText(file);

          case 2:
            text = _context3.sent;

            if (text) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", errorUtils.buildError(errorUtils.failedToReadFile(file)));

          case 5:
            csv = null;
            _context3.prev = 6;
            csv = (0, _sync.default)(text, {
              ltrim: true,
              rtrim: true,
              relax_column_count: true
            });
            _context3.next = 13;
            break;

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](6);
            return _context3.abrupt("return", errorUtils.buildError(_context3.t0.message));

          case 13:
            if (csv) {
              _context3.next = 15;
              break;
            }

            return _context3.abrupt("return", errorUtils.buildError(errorUtils.failedToReadFile(file)));

          case 15:
            _csv = csv, _csv2 = (0, _toArray2.default)(_csv), columns = _csv2[0], rows = _csv2.slice(1);
            defaultedColumns = columns || [];
            trimmedColumns = (0, _last.default)(defaultedColumns) === '' ? (0, _dropRight.default)(defaultedColumns, 1) : defaultedColumns;
            return _context3.abrupt("return", {
              columns: trimmedColumns,
              rows: rows || [],
              error: null
            });

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[6, 10]]);
  }));
  return _readCsvFile.apply(this, arguments);
}

function readXlsFile(_x4) {
  return _readXlsFile.apply(this, arguments);
}

function _readXlsFile() {
  _readXlsFile = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee4(file) {
    var _window, XLSX, buffer, workbook, sheetName, sheet, sheetRange, columns, trimColumns, rows;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _window = window, XLSX = _window.XLSX;

            if (XLSX) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", errorUtils.buildError(errorUtils.failedToReadFile(file)));

          case 3:
            _context4.next = 5;
            return readBuffer(file);

          case 5:
            buffer = _context4.sent;

            if (buffer) {
              _context4.next = 8;
              break;
            }

            return _context4.abrupt("return", errorUtils.buildError(errorUtils.failedToReadFile(file)));

          case 8:
            workbook = null;
            _context4.prev = 9;
            workbook = XLSX.read(buffer, {
              type: 'buffer'
            });
            _context4.next = 16;
            break;

          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](9);
            return _context4.abrupt("return", errorUtils.buildError(_context4.t0.message));

          case 16:
            if (workbook) {
              _context4.next = 18;
              break;
            }

            return _context4.abrupt("return", errorUtils.buildError(errorUtils.failedToReadFile(file)));

          case 18:
            sheetName = workbook.SheetNames[0];

            if (!(0, _isNil.default)(sheetName)) {
              _context4.next = 21;
              break;
            }

            return _context4.abrupt("return", errorUtils.buildError(errorUtils.missingWorksheet()));

          case 21:
            sheet = workbook.Sheets[sheetName];
            sheetRange = XLSX.utils.decode_range(sheet['!ref']);
            columns = (0, _range.default)(sheetRange.s.c, sheetRange.e.c + 1).map(function (col) {
              var cell = XLSX.utils.encode_cell({
                c: col,
                r: sheetRange.s.r
              });
              return XLSX.utils.format_cell(sheet[cell]);
            });
            trimColumns = columns.map(function (column) {
              return column.trim();
            });
            rows = (0, _range.default)(sheetRange.s.r + 1, sheetRange.e.r + 1).map(function (row) {
              return (0, _range.default)(sheetRange.s.c, sheetRange.e.c + 1).map(function (col) {
                var cell = XLSX.utils.encode_cell({
                  c: col,
                  r: row
                });
                return XLSX.utils.format_cell(sheet[cell]);
              });
            });
            return _context4.abrupt("return", {
              columns: trimColumns,
              rows: rows,
              error: null
            });

          case 27:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[9, 13]]);
  }));
  return _readXlsFile.apply(this, arguments);
}

function getFileExtension(file) {
  var fileExtension = file.name.split('.').pop().toLowerCase();
  return fileExtension;
}